import aT from '../const/action-type'
import initial from '../store/initial'

export default (state = initial.reply, action) => {
  switch (action.type) {
    case aT.SET_REPLY:
      return action.data
    case aT.RESET_STORE:
      return initial.reply
    case aT.SWITCH_WORKSPACE:
      return initial.reply
    default:
      return state
  }
}
